












































































































































import {Component, Mixins, Prop} from 'vue-property-decorator';
import Badge from '@/components/ui/Badge.vue';
import TranslatedRouter from '@/mixins/TranslatedRouter';
import {TranslateResult} from 'vue-i18n';

@Component({
	components: {
		'v-badge': Badge
	}
})
export default class PriceCard extends Mixins(TranslatedRouter) {
	@Prop({required: true}) readonly card: any;
	@Prop({default: () => ([])}) readonly classes?: Array<string>;

	get classList(): (string | null)[] {
		return [
			'price-card',
			typeof this.card.type !== 'undefined' ? `price-card--${this.card.type}` : null,
			...(this.classes || [])
		]
	}

	get includes(): TranslateResult {
		return this.$t('pricing.includes');
	}

	get currentCardPreview(): boolean {
		return this.$route.path.replace(/[^a-z0-9-]/g, '') === `orka-${this.card.type}`;
	}

	get appModalName(): string {
		return this.$t('routes.getApp.modalName') as string;
	}

	uCFirst(string: string): string {
		return `${string.charAt(0).toLocaleUpperCase()}${string.slice(1)}`;
	}

	pushToGa(cardType: string): void {
		this.$root.$emit('trackToGTM', ['btnClick', cardType]);
	}

}
